export default "__VITE_ASSET__DGe7hgDP__"